<gstar-entity-types-grid
  [source]="entityTypes()"
  [query]="query"
  (queryChange)="queryUpdate($event)"
  (create)="create($event)"
  (update)="update($event)" />
